import type { AdminStats } from "@storyline/shared";
import { useEffect, useState } from "react";
import { getAdminStats } from "@/src/dashboard/services/admin-stats-http.service";

export const useAdminStats = () => {
	const [stats, setStats] = useState<AdminStats | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		let active = true;
		const run = async () => {
			try {
				const data = await getAdminStats();
				if (active) {
					setStats(data);
					setHasError(false);
				}
			} catch {
				if (active) {
					setHasError(true);
				}
			} finally {
				if (active) {
					setIsLoading(false);
				}
			}
		};
		void run();
		return () => {
			active = false;
		};
	}, []);

	return { stats, isLoading, hasError };
};
